import { ProductImage, reduceImageFromUrl } from '@grupoboticario/barril-del-chavo'
import { Box, Button, Text } from '@grupoboticario/flora-react'
import { ShoppingBagIcon } from '@grupoboticario/flora-react-icons'
import { useEffect, useState } from 'react'

import * as Styled from '../Styles'

import { FavoritesToggle, ProductPrice, LowStockTag } from './ShopWindowProductCard.components'
import { ShopWindowProductCardProps } from '../types'
import { useCart } from 'src/hooks'
import { useResellerContext } from 'src/hooks/useResellerContext'
import { trackShopWindowGAEvents } from 'src/service/trackShopWindowGAEvents'
import { getConfig } from 'src/helpers'

export const ShopWindowProductCard = ({
  product,
  shopWindowType,
  cycle,
}: ShopWindowProductCardProps): JSX.Element => {
  const { isEuAmoMake } = getConfig()
  const { addToCart, isLoading } = useCart()
  const reseller = useResellerContext()

  const [image, setImage] = useState('')

  useEffect(() => {
    if (product.images && product.images.length) {
      setImage(reduceImageFromUrl(product.images[0], 300))
    }
  }, [product.images])

  const trackProductNavigation = () => {
    trackShopWindowGAEvents({
      cd_interaction_detail: 'click:ver-produto',
      listName: shopWindowType,
      cycle,
    })
  }

  return (
    <Styled.Wrapper>
      <Styled.LinkWrapper
        role="button"
        to={`/${reseller?.reseller?.catalogSlug}/produto/${product.sku}`}
        reloadDocument
        aria-label={`Ver mais detalhes de ${product.name}`}
        onClick={trackProductNavigation}
      >
        <Styled.ImageWrapper>
          <FavoritesToggle product={product} />
          <ProductImage
            image={image}
            alt="Imagem do produto"
            css={{
              height: '100%',
              width: '100%',
            }}
          />
        </Styled.ImageWrapper>
        <Styled.Name>
          <Text
            color="$nonInteractivePredominant"
            size="bodyMediumShort"
            weight="medium"
            css={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              display: '-webkit-box',
              '-webkit-line-clamp': 3,
              '-webkit-box-orient': 'vertical',
              whiteSpace: 'normal',
            }}
          >
            {product.name || product.description}
          </Text>
        </Styled.Name>

        {product?.tags && product?.tags?.length > 0 ? <LowStockTag tags={product.tags} /> : null}
        <ProductPrice product={product} />
      </Styled.LinkWrapper>

      <Box css={{ padding: '0' }}>
        <Button
          variant={isEuAmoMake ? 'conversion' : 'standard'}
          isFull
          rightIcon={<ShoppingBagIcon size={16} />}
          onClick={() => addToCart([product], shopWindowType)}
          isLoading={isLoading}
        >
          Adicionar
        </Button>
      </Box>
    </Styled.Wrapper>
  )
}
